import React from "react";
import SearchSelectBox from "../SearchSelectBox";
import { EmploymentStatus, employmentStatusNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";
import { isEmpty } from "../../common/StaticExports";

const EmploymentStatusSelect = (props:any) => {
    const { value, manageSelect, isReadOnly } = props;
    const [t] = useTranslation();
    const options = [
        { value: EmploymentStatus.ES_FULL_TIME, name: t(employmentStatusNaming[EmploymentStatus.ES_FULL_TIME]) },
        { value: EmploymentStatus.ES_PART_TIME, name: t(employmentStatusNaming[EmploymentStatus.ES_PART_TIME]) },
        { value: EmploymentStatus.ES_CONSULTANT, name: t(employmentStatusNaming[EmploymentStatus.ES_CONSULTANT]) },
        { value: EmploymentStatus.ES_STUDENT, name: t(employmentStatusNaming[EmploymentStatus.ES_STUDENT]) },
        { value: EmploymentStatus.ES_VOLUNTEER, name: t(employmentStatusNaming[EmploymentStatus.ES_VOLUNTEER]) },
    ];

    return (
        <>
            <SearchSelectBox
            options={options}
            selectedValue={value}
            manageSelect={(e:any) => {manageSelect(e.value)}}
            label={t('DC_5_EMPLOYMENT_STATUS')}
            isError={isEmpty(value)}
            errorMessage={t('REQUIRED')}
            disabled={isReadOnly}
            />
        </>
    );
}

export default EmploymentStatusSelect;